<template>
  <div class="container">
    <app-header title="登录"
                @onClickRight='clickRight' />
    <van-form @submit="onSubmit">
      <van-field style="margin-top: 50px"
                 v-model="form.username"
                 name="手机号码"
                 label="+86"
                 placeholder="请获取手机号码"
                 :rules="[{ required: true, message: '请获取手机号码' }]">
      </van-field>

      <van-field style="margin-top: 26px"
                 v-model="form.code"
                 name="验证码"
                 placeholder="请输入验证码"
                 :rules="[{ required: true, message: '请输入验证码' }]">
        <template #button>
          <van-button :disabled="disabled"
                      @click="getcode"
                      class="panel"
                      size="small"
                      type="default">{{time}}</van-button>
        </template>
      </van-field>

      <div class="read">
        <van-checkbox v-model="checked"
                      shape="square">
          <span class="remark">我已阅读《用户注册条款协议》</span>
        </van-checkbox>
      </div>

      <div class="login">
        <van-button block
                    color="#E2174B"
                    native-type="submit">
          <span style="color: #ffffff">登录</span>
        </van-button>
      </div>
      <!--<div class="login" @click="onSubmit">登录</div>-->
    </van-form>

    <div class="weChatimg">
      <img @click="weChartLogin" src="@/assets/pay05.png" height="42" width="42"/>
    </div>
    <!-- <div class="weChatl" @click="weChartLogin" >微信授权登录</div> -->
  </div>
</template>

<script>

import { getNOteCode, wxlogin } from '../../api/login/index.js'
import { getUrlParam } from '../../utils/utils.js'

export default {
  name: 'Index',
  data () {
    return {
      form: {
        username: '',
        password: '',
        headImg : ""
      },
      checked: true,
      time: '获取验证码',
      close: '',
      disabled: false
    }
  },
  created () {
    if (this.$route.query.openid != undefined) {
      this.headImg = localStorage.getItem('headImg')
      localStorage.setItem("openid", this.$route.query.openid)
      localStorage.setItem("headImg",this.$route.query.headImg)
      localStorage.setItem("nickname",this.this.$route.query.nickname)
    }
  },
  methods: {
    getcode () {
      const params = {
        phone: this.form.username
      }
      this.disabled = true
      getNOteCode(params).then((res) => {
        console.log(res.success)
        if (res.success) {
          this.time = 60
          this.close = setInterval(this.gettime, 1000)
        } else {
          this.disabled = false
        }
      })
    },
    getUrlKey(name){
　　   return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(window.location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    },
    gettime () {
      if (this.time == 0) {
        // 清除js定时器
        clearInterval(this.close)
        this.time = '获取验证码'
        this.disabled = false
      } else {
        this.time--
      }
    },
    onSubmit () {
      this.$store.dispatch('Login', this.form).then((res) => {
        if (res.code == '200') {
          if (this.$route.query.pid != undefined && this.$route.query.pid != null) {
            this.$router.push({
              path: 'product/detail',
              query: { id: this.$route.query.pid}
            })
          } else {
            if (this.getUrlKey('openid') == null) {
              this.$router.go(-1)
            } else {
              window.location.replace("/");
            }
          }
        }
      })
    },
    weChartLogin () {
      wxlogin().then((res) => {
        console.log('asdfads',res)
        window.location = res.data
      })
    },
    clickRight () {
      this.$router.push('/register')
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  .head {
    background-color: #f3f3f3;
    height: 44px;
    line-height: 44px;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
  .panel {
    width: 88px;
    height: 30px;
    background: rgba(7, 193, 96, 1);
    border: 1px solid rgba(7, 193, 96, 1);
    opacity: 1;
    border-radius: 2px;
    color: #ffffff;
  }
  .read {
    padding: 18px 12px;
    .remark {
      display: inline-block;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: rgba(93, 98, 130, 1);
    }
  }
  .weChatimg {
    width: 100%;
    text-align: center;
    margin-top: 38px;
  }
  .weChatl {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 20px;
    color: rgba(51, 51, 51, 1);
    opacity: 1;
  }
  .login {
    width: 95%;
    margin-left: 2%;
    height: 40px;
    background: linear-gradient(
      0deg,
      rgba(244, 4, 66, 1) 0%,
      rgba(226, 23, 75, 0.73) 100%
    );
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    opacity: 1;
    margin-top: 61px;
    margin-bottom: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue